import { __rest } from "tslib";
import Button from 'antd/lib/button';
import React from 'react';
import { BaseField } from 'uniforms';

var SubmitField = function SubmitField(_a, _ref) {
  var _ref$uniforms = _ref.uniforms,
      error = _ref$uniforms.error,
      disabled = _ref$uniforms.state.disabled;

  var inputRef = _a.inputRef,
      value = _a.value,
      props = __rest(_a, ["inputRef", "value"]);

  return React.createElement(Button, Object.assign({
    disabled: !!(error || disabled),
    htmlType: "submit",
    ref: inputRef,
    type: "primary"
  }, props), value);
};

SubmitField.contextTypes = BaseField.contextTypes;
SubmitField.defaultProps = {
  value: 'Submit'
};
export default SubmitField;